import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/3d.png'


const _withScopeId = n => (_pushScopeId("data-v-39a87219"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goods-img" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "pic-img-3d",
  src: _imports_0
}, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "lable"
}
const _hoisted_5 = { class: "down-num" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "goods-item",
    style: _normalizeStyle({
			'margin-right': _ctx.marginTo + 'px',
			'margin-bottom': _ctx.marginBottom + 'px',
		}),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goto(_ctx.goodsinfo.id)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "goods-img-img",
        src: _ctx.goodsinfo.old_avatar
      }, null, 8, _hoisted_2),
      _hoisted_3
    ]),
    _createElementVNode("p", {
      class: _normalizeClass(["title", { NoAttr: !_ctx.goodsinfo.desc }])
    }, _toDisplayString(_ctx.goodsinfo.name), 3),
    (_ctx.goodsinfo.desc)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.goodsinfo.desc), 1))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.goodsinfo.browse) + "次浏览", 1)
  ], 4))
}